import { memo } from 'react';
import FireAlarmBanner from './FireAlarmBanner';
import useGetFireAlarms from './useGetFireAlarms';
import { jsx as _jsx } from "react/jsx-runtime";
const FireAlarmBannerContainer = () => {
  const fireAlarms = useGetFireAlarms();
  if (!fireAlarms.length) {
    return null;
  }
  const fireAlarmBanners = fireAlarms.map(fireAlarm => {
    return /*#__PURE__*/_jsx(FireAlarmBanner, {
      fireAlarm: fireAlarm
    }, fireAlarm.id);
  });
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "fireAlarmContainer",
    children: fireAlarmBanners
  });
};
export default /*#__PURE__*/memo(FireAlarmBannerContainer);